import React from 'react';

function Description({ID, text, technologies}) {
    return (
        <div className={`description${ID}`}>
            <div className={`description${ID}__text`} data-aos="fade-up" data-aos-delay="400">{text}</div>
            <div className={`description${ID}__technologies`}>
                {
                    technologies.map(
                        (tech, i) => (
                            <li data-aos="fade-up" data-aos-delay={(450 + (50 * (i + 1))).toString()}>{tech}</li>
                        )
                    )
                }
            </div>
        </div>
    );
}

export default Description



// WEBPACK FOOTER //
// ./src/Components/Projects/JavaScript/Description.js